import { LendHistorySearchFlag } from '@/api'

export interface CreateInterLibraryLoanLendListRequest {
  searchFlag: LendHistorySearchFlag
  lendDate: string
  lendDateFrom: string
  lendDateTo: string
}

export const defaultCreateInterLibraryLoanLendListRequest = (): CreateInterLibraryLoanLendListRequest => ({
  searchFlag: LendHistorySearchFlag.PrefixMatch,
  lendDate: '',
  lendDateFrom: '',
  lendDateTo: ''
})

export function CreateInterLibraryLoanLendListRequestToJSON(
  value: CreateInterLibraryLoanLendListRequest
): any {
  return {
    search_flag: value.searchFlag ? value.searchFlag : undefined,
    lend_date: value.lendDate !== '' ? value.lendDate : undefined,
    lend_date_from: value.lendDateFrom !== '' ? value.lendDateFrom : undefined,
    lend_date_to: value.lendDateTo !== '' ? value.lendDateTo : undefined
  }
}
